const filterByRequirement = ([context, menuItems]) => [
    context,
    menuItems.filter((menuItem) => menuItem.requirement(context)),
];

export default filterByRequirement;
